<template>
  <ul class="dropdown-menu" :style="position" v-if="showMenu && event != null" @mousedown.stop.prevent @mouseup.stop.prevent>
    <slot></slot>
  </ul>
</template>
<script>
export default {
  props: ['event'],
  data() {
    return {
      position: {
        top: 0,
        left: 0
      },
      showMenu: false
    };
  },
  methods: {
    calculatePosition() {
      const rect = this.$el.getBoundingClientRect();
      let left = this.event.x;
      let top = this.event.y;

      if (left + rect.width > window.innerWidth) {
        left = window.innerWidth - rect.width;
      }
      if (top + rect.height > window.innerHeight) {
        top -= rect.height;
      }

      this.position = { left: left + 'px', top: top + 'px' };

      const windowEvents = ['mousedown', 'mouseup', 'mousewheel', 'click'];
      const handleEvent = () => {
        this.showMenu = false;
        windowEvents.forEach((f) => window.removeEventListener(f, handleEvent));
      };
      windowEvents.forEach((f) => window.addEventListener(f, handleEvent));
    },
  },
  watch: {
    event() {
      if (this.event) {
        this.showMenu = true;
        this.$nextTick(() => this.calculatePosition());
      }
    }
  },
};
</script>

<style>
.dropdown-menu {
  position: fixed;
  z-index: 1000;
  float: left;
  min-width: 160px;
  padding: 5px 0;
  margin: 2px 0 0;
  font-size: 14px;
  text-align: left;
  list-style: none;
  background-color: #fff;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid #ccc;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
}

.dropdown-menu > li {
  display: block;
  padding: 4px 20px;
  clear: both;
  font-weight: 400;
  line-height: 1.42857143;
  color: #333;
  white-space: nowrap;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

.dropdown-menu > li:hover {
  background-color: rgb(238, 236, 236);
}
</style>